
/**
 * Represents a type of nudge that can be shown to users.
 * Nudges are prompts or notifications that encourage specific user actions.
 */
export class NudgeType {
    public static readonly SUGGEST_PANDA_BOT = new NudgeType(
        "suggest_panda_bot",
        "Suggest Panda Bot",
    );

    static values(): NudgeType[] {
        return [
            NudgeType.SUGGEST_PANDA_BOT,
        ];
    }

    private readonly id: string;
    private readonly name: string;

    private constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }

    getID(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    static getByID(id: string): NudgeType {
        for (const nudgeType of NudgeType.values()) {
            if (nudgeType.id === id)
                return nudgeType;
        }
        throw new Error(`Unknown nudge type: ${id}`);
    }

    static getByIDOrNull(id: string | null): NudgeType | null {
        if (id === null)
            return null;
        for (const nudgeType of NudgeType.values()) {
            if (nudgeType.id === id)
                return nudgeType;
        }
        return null;
    }
}
